import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("pending");
  return { navigate, activeTab, setActiveTab };
};
